import computed from './computed'
import props from './props'

export default {
  computed,
  props
}



// WEBPACK FOOTER //
// ./src/app/settings/covenants/index/components/resources/index.js